<template>
    <section class="container h-screen flex items-center">
      <p-plug class="" />
    </section>
  </template>
  